import React from 'react'
import TopNav from '../components/TopNav'
import GmaBanner from '../components/GmaBanner'
import Footer from '../components/Footer'

const CommunityEngagementPage: React.FC = () => {
    return (
        <>
            <TopNav />
            <div className="container-fluid w-100 h-auto m-0 p-0">
                <img
                    src="./img/communityheader.jpg"
                    className="img-fluid w-100 pt-4 mt-5 top-image"
                    alt="Community engagement event"
                    style={{ height: '100%' }}
                />
            </div>
            <section className="" style={{ padding: '0', margin: 0 }}>
                <div className="container-fluid" style={{ padding: 0, margin: 0 }}>
                    <div className="row" style={{ padding: 0, margin: 0 }}>
                        <div className="col" style={{ padding: 0, margin: 0 }}>
                            <div className="text-center" style={{ backgroundColor: '#908068', color: 'black' }}>
                                <h1 className="text-uppercase py-1 subheading">Community Engagement</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row my-5">
                        <div className="col">
                            <div className="text-center">
                                <h5 className="section-subheading text-muted">
                                    The House celebrates the present state of Black creativity, innovation, and excellence. The House creates a sense of
                                    empowerment and agency within the community by providing opportunities for individuals to en gage in unique activities,
                                    discussions, and advocacy work, by providing access to resources and support networks that may not be available elsewhere.
                                    The House uplifts artists, educators, nonprofits, and vendors who are invested in increasing cross-cultural understanding
                                    and advancing racial diversity, equity, and inclusion.
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="row">
                <div className="col">
                    <GmaBanner />
                </div>
            </div>

            <Footer />
        </>
    )
}

export default CommunityEngagementPage
